import { useTranslation } from "react-i18next";
import { Input } from "@/components/atomic/Input";
import { ChatAttributeFilter, createChatTextualAttributeFilter } from "@/components/ui/chat/chatFilterUtils";
import { Attribute, AttributeType } from "@/models/attribute";

interface TextualAttributeFilterProps {
  attribute: Attribute;
  currentFilter: ChatAttributeFilter | undefined;
  onFilterChange: (attributeName: string, filter: ChatAttributeFilter | null) => void;
}

export const TextualAttributeFilter: React.FC<TextualAttributeFilterProps> = ({
  attribute,
  currentFilter,
  onFilterChange,
}) => {
  const { t } = useTranslation("voiceek_ui");

  const textValue = (currentFilter?.filter.type === AttributeType.TEXTUAL)
    ? currentFilter.filter.value
    : "";

  const handleChange = (value: string) => {
    if (value) {
      const chatFilter = createChatTextualAttributeFilter(value);
      onFilterChange(attribute.name, chatFilter);
    } else {
      onFilterChange(attribute.name, null);
    }
  };

  return (
    <div className="flex flex-col gap-2 my-4">
      {/* テキスト検索 */}
      <div className="flex items-center gap-2">
        <Input
          type="text"
          value={textValue}
          onChange={(e) => handleChange(e.target.value)}
          className="w-[300px] text-[14px] min-h-[32px] py-2 px-3 border-[#b7b7b7] shadow-none placeholder:text-[#b7b7b7]"
          placeholder={t("chat.filter.keywordInput")}
        />
      </div>

      {/* エラーメッセージ */}
      {currentFilter?.error && (
        <p className="text-[12px] text-red-500">
          {t(currentFilter.error)}
        </p>
      )}
    </div>
  );
};
